<template>
  <div class="kw_file_preview" v-loading="isLoading">
    <!-- pdf预览 -->
    <template v-if="value.fileOneInfo.F_TYPE == 'pdf' || value.fileOneInfo.fileType == 'pdf'">
      <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">Preview</span>
      {{currentPage}} / {{pageCount}}
      <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">Next</span>
      <pdf :src="GLOBAL.getFileServeUrl()+value.fileOneInfo.downAddress" :page="currentPage" 
      @num-pages="pageCount=$event" 
      @page-loaded="currentPage=$event" 
      @loaded="loadPdfHandler"></pdf>
    </template>
    <!-- 图片预览 -->
    <template v-else-if="(value.fileOneInfo.F_TYPE == 'jpg' || value.fileOneInfo.F_TYPE == 'jpng' || value.fileOneInfo.F_TYPE == 'png' || value.fileOneInfo.fileType == 'image') && imgList.length > 0">
      <viewer ref="img_viewer" :options="{hidden:hiddenAAA}" :images="imgList">
        <img  v-for="(src,index) in imgList" :key="index" :src="src" style="width: 50px;height:50px;" >
      </viewer>
    </template>
    <!-- word预览 -->
    <!-- excel预览 -->
    <div id="iframeBox" v-else-if="(value.fileOneInfo.F_TYPE == 'office' ||value.fileOneInfo.fileType == 'office') && iframeViewUrl">
      <iframe v-show="ifLoadedOffice" ref="office_iframe" id="office_iframe" width="100%" :height="tableMaxHeight" frameborder='no' border='0' marginwidth='0' marginheight='0' scrolling='no' allowtransparency='yes' :src="iframeViewUrl"></iframe>
      <!-- :src="'https://view.officeapps.live.com/op/view.aspx?src='+(GLOBAL.getFileServeUrl()+value.fileOneInfo.downAddress)" -->
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import signclient from '@/js/utils/signclient.js';
export default {
  name: 'kw_file_preview',
  props: {
    value:{
      type: Object,
      default: function(){
        return {};
      }
    }
  },
  data() {
    return {
      appId : "yozomJqjbArs9077",
      appKey : "a643bb338a90c013caeff6123b0a",
      editAppId:"yozokMCTYkfR8173",
      editAppKey:"f6f9ea9e200de5d90be6e8a9c609",
      htmlTitle : "",//慧读国际
      isLoading:false,
      // 图片预览组件的图片源
      imgList:[],
      currentPage: 0, // pdf文件页码
      pageCount: 0,
      ifLoadedOffice:true,
      iframeViewUrl:null,
      tableMaxHeight:600
    };
  },
  created() {
    var that = this;
    var fileOneInfo = this.value.fileOneInfo;
    if(fileOneInfo.downAddress) {
      if(fileOneInfo.F_TYPE == 'jpg' || fileOneInfo.F_TYPE == 'jpng' || fileOneInfo.F_TYPE == 'png' || fileOneInfo.fileType == 'image') {
        var imgList = [];
        if(fileOneInfo.downAddress.indexOf(",")>0) {
          var tmpImgArr = fileOneInfo.downAddress.split(",");
          for (let index = 0; index < tmpImgArr.length; index++) {
            const element = tmpImgArr[index];
            imgList.push(element.startsWith("http")?element:(this.GLOBAL.getFileServeUrl()+element));
          }
        } else {
          var src = this.GLOBAL.getFileServeUrl()+fileOneInfo.downAddress;
          imgList.push(src);
        }
        this.imgList = imgList;
      }
    } else {
      var options = this.$route.query;
      this.value.fileOneInfo.F_TYPE = options.F_TYPE;
      this.value.fileOneInfo.downAddress = options.downAddress;
    }
  },
  mounted() {
    var that = this;
    if(this.$refs.img_viewer) {
      console.log("Viewer===================",this.$refs.img_viewer);
      this.$refs.img_viewer.$viewer.show();
      this.hiddenPreviewDialog();
    }

    var windowHeight = window.innerHeight;
    
    // 判断搜索条件个数
    this.tableMaxHeight = windowHeight-30;

    console.log("this.value.fileOneInfo===============================",this.value.fileOneInfo);
    //office预览 判断页面是否加载完毕 加载完毕则 进行下载按钮隐藏
    if(this.value.fileOneInfo.F_TYPE == "office" || this.value.fileOneInfo.fileType == "office") {
      this.getYongZhongFileId();
    }
  },
  watch:{
  },
  computed:{
  },
  components: {
    pdf
  },
  methods: {
    hiddenAAA(){
      console.log("预览组件关闭!");
      // 是否有背景音频播放 如果有进行关闭
      this.destoryPreviewDialog();
    },
    changePdfPage (val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
        // console.log(this.currentPage)
      }
    },

    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    //获取永中的文件id
    getYongZhongFileId(){
      var that = this;
      that.isLoading = true;
      var fileVersionId = "";
      var fieldEnName = "YZ_FILE_VERSION_ID";
      var fileEditType = this.value.fileOneInfo.fileEditType;
      if(fileEditType == 1) {
        fieldEnName = "YZ_EDIT_FILE_VERSION_ID";
      }
      utils.request(that,{
        url: 'file_updateInfo.do', //仅为示例，并非真实的接口地址
        data: {
          tableId:4,
          type:2,
          cName:fieldEnName,
          wName:"F_MONGOID",
          wValue:that.value.fileOneInfo.downAddress
        },
        success: function (res) {
            that.isLoading = false;
            if(res.data.errorcode == 0) {
              var fileList = res.data.data;
              if(fileList && fileList.length > 0) {
                if(fileList[0]!=null) {
                  fileVersionId = fileList[0][fieldEnName];
                }
                if(fileVersionId != null && fileVersionId != "") {
                  that.getYongZhongUrl(fileVersionId);
                } else {
                  that.uploadYongZhongFile();
                }
              }
            }
        }
      })
      
    },
    /**
     * 向永中服务器上传文件 并记录文件版本ID
     */
    uploadYongZhongFile() {
      var that = this;
      // var firstUrl = "https://www.yozodcs.com/fcscloud/file/http";
      // var twoUrl = "https://www.yozodcs.com/fcscloud/composite/convert";
      var toHtData = {
        fileUrl:this.GLOBAL.getFileServeUrl()+this.value.fileOneInfo.downAddress
      }
      var firstUrl = "https://dmc.yozocloud.cn/api/file/http";
      var fileEditType = this.value.fileOneInfo.fileEditType;
      var fieldEnName = "YZ_FILE_VERSION_ID";
      var appId =  that.appId;
      var appKey = that.appKey;
      if(fileEditType == 1) {
        fieldEnName = "YZ_EDIT_FILE_VERSION_ID";
        appId =  that.editAppId;
        appKey = that.editAppKey;
      }
      toHtData.appId = appId;
      var signJson = {
        appId:[toHtData.appId],
        fileUrl:[toHtData.fileUrl]
      }
      var sign = signclient.generateSign(appKey,signJson);
      console.log("sign=====================",sign);
      toHtData.sign = sign;
      firstUrl += "?" + pageUtils.jsonToParamStr(toHtData);
      console.log("firstUrl=====================",firstUrl);
      that.$axios.post(firstUrl,{}).then(res => {
        console.log("res========================",res);
        // var tmpRul = res.data.data.data;
        var fileId = res.data.data.fileId;
        var fileVersionId = res.data.data.fileVersionId;
        //去系统后台进行fileVersionId记录
        that.isLoading = true;
        utils.request(that,{
          url: 'file_updateInfo.do', //仅为示例，并非真实的接口地址
          data: {
            tableId:4,
            type:1,
            cName:fieldEnName,
            cValue:fileVersionId,
            wName:"F_MONGOID",
            wValue:that.value.fileOneInfo.downAddress
          },
          success: function (res) {
            that.isLoading = false;
            if(res.data.errorcode == 0) {
              //记录成功
            }
            that.getYongZhongUrl(fileVersionId);
          }
      })
      }).catch(error => {
          console.log("error========" , error);
      })
    },
    //使用永中免费版官网接口
    uploadYongZhongFileMianfei(){
        var that = this;
      // var firstUrl = "https://www.yozodcs.com/fcscloud/file/http";
      // var twoUrl = "https://www.yozodcs.com/fcscloud/composite/convert";
      var toHtData = {
        fileUrl:this.GLOBAL.getFileServeUrl()+this.value.fileOneInfo.downAddress
      }
      console.log("firstUrl=====================",firstUrl);
      that.$axios.post(firstUrl,toHtData).then(res => {
        console.log("res========================",res);
        var tmpRul = res.data.data.data;
        console.log("twoUrl================================",twoUrl);
        that.$axios.post(twoUrl,{
          srcRelativePath:tmpRul,
          convertType: 61,
          isDccAsync: 1,
          isCopy: 1,
          fileUrl: this.GLOBAL.getFileServeUrl()+this.value.fileOneInfo.downAddress,
          time: 1800
        }).then(res => {
          var viewUrl = res.data.data.viewUrl;
          console.log("viewUrl=======================",viewUrl);
          that.iframeViewUrl = viewUrl
        }).catch(error => {
            console.log("error========" , error);
        })
      }).catch(error => {
          console.log("error========" , error);
      })
    },
    /**
     * 获取永中的预览地址
     */
    getYongZhongUrl(fileVersionId) {
      var that = this;
      //判断是打开永中文件预览 还是永中文件编辑功能
      var fileEditType = this.value.fileOneInfo.fileEditType;
      if(fileEditType == 1) {
        // fileVersionId = fileVersionId.substring(0,fileVersionId.indexOf("_"));
        //永中文件编辑功能
        var editUrl = "http://eic.yozocloud.cn/api/edit/file"
        var signJson = {
          fileVersionId:[fileVersionId],
          appId:[that.editAppId]
        }
        var sign = signclient.generateSign(that.editAppKey,signJson);
        editUrl += "?" + pageUtils.jsonToParamStr({
          fileVersionId:fileVersionId,
          appId:that.editAppId,
          sign:sign
        });
        var options = this.$route.query;
        if(options.downAddress) {
          window.location.href=editUrl;
        } else {
          window.open(editUrl);
          that.hiddenPreviewDialog();
        }
      } else {
        var twoUrl = "https://eic.yozocloud.cn/api/view/file";
        var signJson = {
          fileVersionId:[fileVersionId],
          appId:[that.appId],
          isCopy:[1],
          viewType:[1],
          watermark:[that.htmlTitle],
          htmlTitle:[that.htmlTitle],
          expiration:[7200],
          isDownload:[0]
        }
        var sign = signclient.generateSign(that.appKey,signJson);
        twoUrl += "?" + pageUtils.jsonToParamStr({
          fileVersionId:fileVersionId,
          appId:that.appId,
          isCopy:1,
          viewType:1,
          watermark:that.htmlTitle,
          htmlTitle:that.htmlTitle,
          expiration:7200,
          isDownload:0,
          sign:sign
        });
        // that.iframeViewUrl = twoUrl;
        var options = this.$route.query;
        console.log("twoUrl=======================",twoUrl,options);
        if(options.downAddress) {
          window.location.href=twoUrl;
        } else {
          var ifWxMiniProgram = false;
          wx.miniProgram.getEnv(function(res) {
              if(res.miniprogram) {
                window.location.href=twoUrl;
                ifWxMiniProgram = true;
              }
          })
          if(!ifWxMiniProgram) {
            window.open(twoUrl);
          }
          that.hiddenPreviewDialog();
        }
      }
    },
    /**
     * 隐藏预览组件
     */
    hiddenPreviewDialog:function(){
        this.value.ifShow = false;
        console.log("this.value============111==============",this.value);
    },
    /**
     * 销毁预览组件
     */
    destoryPreviewDialog:function(){
      var that = this;
      this.value.ifLoad = false;
      if(this.value.fileOneInfo.backGroundAudio) {
        // 是否有背景音频播放 如果有进行关闭
        pageUtils.destoryBackGroundAudio(that);
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
